import React from "react";
import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";

const Routes: React.FC = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  return token && role ? <AppRoutes role={role} /> : <AuthRoutes />;
};

export default Routes;
